export const PORTAL_HAT_MUZZLE_PIXELS = {x: 53, y: -40};
export const PORTAL_HAT_OFFSET_LENGTH = 24;
export const PORTAL_HAT_OFFSET_ANGLE = Math.PI / 2 * 0.6;

export const getPortalHatMuzzle = (position, bodyAngle, flipped, ptm) => {
	const facing = flipped ? -1 : 1;
	const textureOffsetX = PORTAL_HAT_OFFSET_LENGTH * Math.cos(-PORTAL_HAT_OFFSET_ANGLE);
	const textureOffsetY = PORTAL_HAT_OFFSET_LENGTH * Math.sin(-PORTAL_HAT_OFFSET_ANGLE);
	const localX = (PORTAL_HAT_MUZZLE_PIXELS.x + textureOffsetX) / ptm * facing;
	const localY = (PORTAL_HAT_MUZZLE_PIXELS.y + textureOffsetY) / ptm;
	const cos = Math.cos(bodyAngle);
	const sin = Math.sin(bodyAngle);
	return {
		angle: bodyAngle + (flipped ? Math.PI : 0),
		position: {
			x: position.x + localX * cos - localY * sin,
			y: position.y + localX * sin + localY * cos,
		},
	};
};
